/* eslint-disable @typescript-eslint/no-unused-vars */
import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { signedGuard } from './guards/signed.guard';
import { noCommercialeGuard } from './guards/no-commerciale.guard';
import { onlyCommercialeGuard } from './guards/only-commerciale.guard';
import { MainLayoutComponent } from './components/layouts/main-layout/main-layout.component';

export const routes: Routes = [
   {
    path: '',
    canActivate: [authGuard],
    component: MainLayoutComponent,
    children: [
      {
        path: 'contracts',
        canActivate: [noCommercialeGuard],
        async loadComponent() {
          const m = await import('./components/contract/contract-table/contract-table.component');
          return m.ContractTableComponent;
        },
      },
      {
        path: 'contracts/detail/:id',
        canActivate: [noCommercialeGuard],
        async loadComponent() {
          const m = await import('./components/contract/detail-contract/tab-contract/tab-contract.component');
          return m.TabContractComponent;
        },
      },
      {
        path: 'contracts/detail/:id/sap/:contractId',
        canActivate: [noCommercialeGuard],
        async loadComponent() {
          const m = await import('./components/business/business-detail/business-contract-detail/sap-view/sap-view.component');
          return m.SapViewComponent;
        },
      },
      {
        path: 'businesses',
        canActivate: [onlyCommercialeGuard],
        async loadComponent() {
          const m = await import('./components/business/business.component');
          return m.BusinessComponent;
        },
      },
      {
        path: 'contracts/:contractId',
        canActivate: [noCommercialeGuard],
        async loadComponent() {
          const m = await import('./components/business/business-detail/business-contract-detail/business-contract-detail.component');
          return m.BusinessContractDetailComponent;
        },
      },
      {
        path: 'businesses/:id/contracts/:contractId',
        canActivate: [onlyCommercialeGuard],
        async loadComponent() {
          const m = await import('./components/business/business-detail/business-contract-detail/business-contract-detail.component');
          return m.BusinessContractDetailComponent;
        },
      },
      {
        path: 'businesses/contract-documentation/:contractId',
        canActivate: [onlyCommercialeGuard],
        async loadComponent() {
          const m = await import('./components/business/business-detail/business-contract-documentation/business-contract-documentation.component');
          return m.BusinessContractDocumentationComponent;
        },
      },
      {
        path: 'businesses/:id',
        canActivate: [onlyCommercialeGuard],
        async loadComponent() {
          const m = await import('./components/business/business-detail/business-detail.component');
          return m.BusinessDetailComponent;
        },
      },
      {
        path: 'businesses/:id/sap/:contractId',
        canActivate: [onlyCommercialeGuard],
        async loadComponent() {
          const m = await import('./components/business/business-detail/business-contract-detail/sap-view/sap-view.component');
          return m.SapViewComponent;
        },
      },
      {
        path: '',
        redirectTo: 'contracts',
        pathMatch: 'full'
      },
    ],
  },
  {
    path: 'login',
    canActivate: [signedGuard],
    async loadComponent() {
      const m = await import('./components/login/login.component');
      return m.LoginComponent;
    },
  },

  {
    path: 'forgot-password',
    canActivate: [signedGuard],
    async loadComponent() {
      const m = await import(
        './components/forgot-password/forgot-password.component'
      );
      return m.ForgotPasswordComponent;
    },
  },
];
